const url = __webpack_public_path__ + "search/474558196b96adf9a766.tr.js";
export default url;